module.exports = __webpack_public_path__ + "img/meiridati.278e7538.png";